import React from 'react'
import { Edit } from 'react-admin'
import Form from './form'
import { editOptions } from '../../util/component-options'
import { EmbeddedExtractionMappingsList } from '../../shared'

const TrucksEdit = props => {
  return (
    <>
      <Edit {...editOptions} {...props} >
        <Form />
      </Edit>
      <EmbeddedExtractionMappingsList
        resource='truck_extraction_mappings'
        filter={{
          truck_id_eq: props.id,
        }}
      />
    </>
  )
}

export default TrucksEdit
